module.exports = __webpack_public_path__ + "static/media/download-manager.67aa1d46.png";